var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconArrowRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 15,
    viewBox: "0 0 8 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.74073 6.95647C8.04111 7.2686 8.04111 7.77466 7.74073 8.08679L1.31305 14.7659C1.01267 15.078 0.525661 15.078 0.225283 14.7659C-0.0750942 14.4538 -0.0750942 13.9477 0.225283 13.6356L6.65297 6.95647C6.95335 6.64435 7.44035 6.64435 7.74073 6.95647Z",
    fill: "#4E5060"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.77472 8.04352C7.47434 8.35565 6.98733 8.35565 6.68695 8.04352L0.259268 1.36441C-0.0411091 1.05228 -0.0411091 0.546223 0.259268 0.234096C0.559645 -0.0780315 1.04665 -0.0780315 1.34703 0.234096L7.77472 6.91321C8.07509 7.22534 8.07509 7.7314 7.77472 8.04352Z",
    fill: "#4E5060"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowRight);
export default __webpack_public_path__ + "static/media/icon_arrow_right.3fdd2aecff8a84ee932ca64e9aea8c7a.svg";
export { ForwardRef as ReactComponent };